import { MotivationEnum } from '@graphql/generated';
import { Motivation } from '@lib/models/demande-affiliation/types/motivation.type';

export class MotivationMapper {
  public static fromGraphQl(input?: MotivationEnum[]): Motivation[] | undefined {
    const mapping: Record<string, Motivation> = {
      QUALITE_OFFRE: 'qualite_offre',
      METIER_QUI_A_DU_SENS: 'metier_qui_a_du_sens',
      POSSIBILITE_DOUBLE_ACTIVITE: 'possibilite_double_activite',
      INTERET_METIER_GESTION_PATRIMOINE: 'interet_metier_gestion_patrimoine',
      MODEL_MARKETING_RELATIONEL: 'model_marketing_relationel',
      CREATION_ENTREPRISE: 'creation_entreprise',
      EQUILIBRE_VIE_PROFESSIONNELLE_PERSONNELLE:
        'equilibre_vie_professionnelle_personnelle',
      VALEURS_DU_GROUPE: 'valeurs_du_groupe',
      RELATION_PARRAIN: 'relation_parrain',
      REMUNERATION_SANS_LIMITE: 'remuneration_sans_limite',
      BESOIN_DE_LIBERTE: 'besoin_de_liberte',
    };
    return input ? input.filter(m => m !== null).map(m => mapping[m!]) : undefined;
  }
}
